import { createTheme, responsiveFontSizes } from '@mui/material/styles';

let theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  palette: {
    primary: {
      main: '#ED7420',
      light: '#ff9a52',
      dark: '#c85000',
    },
    secondary: {
      main: '#3A506B',
      light: '#5d748e',
      dark: '#2c3e5a',
    },
    error: { main: '#E74C3C' },
    warning: { main: '#F39C12' },
    info: { main: '#3498DB' },
    success: { main: '#2ECC71' },
    background: { default: '#f5f7fa' },
  },
  typography: {
    fontFamily: '"Roboto", "Segoe UI", sans-serif',
    h1: {
      fontSize: '1.75rem',
      fontWeight: 600,
      color: '#ED7420',
      '@media (min-width:600px)': { fontSize: '2rem' },
    },
    h2: {
      fontSize: '1.35rem',
      fontWeight: 600,
      color: '#3A506B',
      '@media (min-width:600px)': { fontSize: '1.5rem' },
    },
    h3: {
      fontSize: '1.1rem',
      fontWeight: 600,
      color: '#3A506B',
      '@media (min-width:600px)': { fontSize: '1.2rem' },
    },
    subtitle1: {
      color: '#708181',
      fontSize: '0.9rem',
      '@media (min-width:600px)': { fontSize: '1rem' },
    },
    body1: {
      fontSize: '0.95rem',
      '@media (min-width:600px)': { fontSize: '1rem' },
    },
    body2: {
      fontSize: '0.85rem',
      '@media (min-width:600px)': { fontSize: '0.875rem' },
    },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '12px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          padding: '16px',
          marginBottom: '24px',
          '@media (min-width:600px)': { padding: '24px' },
          '@media (min-width:900px)': { padding: '32px', marginBottom: '32px' },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          textTransform: 'uppercase',
          fontWeight: 500,
          letterSpacing: '0.5px',
          padding: '10px 16px',
          minWidth: '100px',
          boxShadow: 'none',
          transition: 'all 0.3s ease',
          fontSize: '0.875rem',
          '&:focus': { outline: 0 },
          '@media (min-width:600px)': { padding: '12px 24px', minWidth: '120px', fontSize: '0.9375rem' },
          touchAction: 'manipulation',
          WebkitTapHighlightColor: 'transparent',
        },
        containedPrimary: {
          backgroundColor: '#ED7420 !important',
          color: '#FFFFFF !important',
          border: '1px solid #ED7420 !important',
          boxShadow: 'none !important',
          '&:hover': { color: '#ff6a00 !important', backgroundColor: '#fff !important', borderColor: '#ff6a00 !important' },
        },
        containedSecondary: {
          backgroundColor: 'transparent !important',
          color: '#ED7420 !important',
          border: '1px solid #ED7420 !important',
          boxShadow: 'none !important',
          '&:hover': { color: '#fff !important', backgroundColor: '#ff6a00 !important', borderColor: '#ff6a00 !important' },
        },
        outlinedPrimary: {
          backgroundColor: 'transparent !important',
          color: '#ED7420 !important',
          border: '1px solid #ED7420 !important',
          boxShadow: 'none !important',
          '&:hover': { color: '#fff !important', backgroundColor: '#ff6a00 !important', borderColor: '#ff6a00 !important' },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          marginBottom: '16px',
          '@media (min-width:600px)': { marginBottom: '24px' },
          '& .MuiInputBase-root': { minHeight: '48px' },
          '& .MuiInputBase-input': { fontSize: '1rem', padding: '12px 14px' },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: { color: '#ED7420', padding: '9px' },
      },
    },
  },
});

theme = responsiveFontSizes(theme);

export default theme;
